var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.layout === 'vertical')?_c('div',[(_vm.label)?_c('label',{class:_vm.labelClass},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('textarea',{staticClass:"form-control",class:[
        {
          'is-invalid': !_vm.isValid,
          'is-valid': _vm.isValid && _vm.value,
        },
        _vm.inputClass,
      ],attrs:{"id":_vm.id,"rows":_vm.rows,"placeholder":_vm.placeholder,"type":_vm.type,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur,"change":_vm.onChange}})]):_vm._e(),(_vm.layout === 'horizontal')?_c('div',{staticClass:"row"},[(_vm.label)?_c('label',{staticClass:"col-md-2 col-form-label",class:_vm.labelClass},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{staticClass:"col-md-10"},[_c('textarea',{staticClass:"form-control",class:[
          {
            'is-invalid': !_vm.isValid,
            'is-valid': _vm.isValid && _vm.value,
          },
          _vm.inputClass,
        ],attrs:{"rows":_vm.rows,"placeholder":_vm.placeholder,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus,"change":_vm.onChange}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }